const extraInfo = {
  hobbies: {
    english: ["Chess", "Programming", "Learning new skills"],
    arabic: ["الشطرنج", "البرمجة", "تعلم المهارات الجديدة"],
  },
  languages: {
    english: [
      "Arabic: mother tongue",
      "English: Professional working proficiency",
      "Dutch: Limited working proficiency",
    ],
    arabic: [
      "العربية: اللغة الأم",
      "الإنكليزية: إجادة العمل المهني",
      "الهولندية: إجادة محدودة ",
    ],
  },
};

export default extraInfo;
